import { Button, Col, Form, Input, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

import { L } from '@lib';
import { Rules } from '@utils';

interface IProps {
  serviceTitle?: string;
  descriptionTitle?: string;
  showCancelButton?: boolean;
  setShowServiceForm?: (value: boolean) => void;
}

export const ServiceFormItems: React.FC<IProps> = ({
  serviceTitle = L('Service name'),
  descriptionTitle = L('Short description'),
  showCancelButton = false,
  setShowServiceForm,
}) => {
  return (
    <>
      <Form.Item name="code" label={L('Code')}>
        <Input placeholder={L('Optional service code, e.g. 1001')} maxLength={32} />
      </Form.Item>
      <Form.Item name="name" label={serviceTitle} rules={Rules.required}>
        <Input placeholder={L('Enter service name')} />
      </Form.Item>
      <Form.Item name="description" label={descriptionTitle}>
        <TextArea
          placeholder={L('Please write description')}
          autoSize={{ minRows: 3 }}
          showCount
          maxLength={100}
        />
      </Form.Item>
      <Row justify="end" hidden={!showCancelButton}>
        <Col>
          <Form.Item>
            <Button
              onClick={() => {
                setShowServiceForm && setShowServiceForm(false);
              }}
              type="default"
            >
              {L('Cancel')}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
